<template>
  <div class="padding-md">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="应用名称">
            <el-select v-model="searchForm.appIndex" placeholder="请选择">
              <el-option
                v-for="item in apps"
                :key="item.appIndex"
                :label="item.appName"
                :value="item.appIndex">
              </el-option>
            </el-select>
            <!--<el-input v-model="searchForm.appIndex"></el-input>-->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="getAppProducts">查询</el-button>
            <el-button type="success" @click="showDialog(false)">添加</el-button>
            <el-button type="success" native-type="submit" @click.native.prevent="putAway">一键上架</el-button>
            <el-button type="success" native-type="submit" @click.native.prevent="soldOut">一键下架</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table :data="appProducts.rows" :stripe="true" v-loading="loading" border style="width: 100%">
          <el-table-column prop="id" width="80" label="ID" v-if="false"></el-table-column>
          <el-table-column prop="appIndex" label="应用名称">
            <template slot-scope="scope">
              {{ findAppName(scope.row.appIndex) }}
            </template>
          </el-table-column>
          <el-table-column prop="productIds" label="商品ids"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="160" width="230">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showDialog(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteAppProducts(scope.row)">删除</el-button>
              <el-button type="danger" size="mini" @click="deleteAppCache(scope.row.appIndex)">清缓存</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="padding-vertical-md"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="appProducts.currentPage"
          :page-sizes="pageSizes"
          :page-size="appProducts.pageSize"
          :page-count="appProducts.totalPages"
          layout="total, sizes, prev, pager, next, jumper"
          :total="appProducts.count">
        </el-pagination>
      </el-col>
    </el-row>
    <!--编辑面板-->
    <el-dialog el-dialog :title="title" :visible.sync="showEditorDialog" class="update"
               :before-close="handleBeforeCloseDialog">
      <el-form :model="formData" ref="formData" label-width="80px" :rules="formRules">
        <el-form-item label="应用" prop="appIndex">
          <el-select v-model="formData.appIndex" placeholder="请选择" :disabled="!!formData.id">
            <el-option
              v-for="item in apps"
              :key="item.appIndex"
              :label="item.appName"
              :value="item.appIndex">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="products" ref="products" border style="width: 100%" height="250"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="150"></el-table-column>
        <el-table-column prop="icon" label="商品图片">
          <template slot-scope="scope">
            <img v-if="scope.row.icon" :src="scope.row.icon" width="40%" height="40%" alt="icon"/>
            <span v-else>Icon</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格/元">
          <template slot-scope="scope">
            <span>{{ scope.row.price | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sellCount" label="钻石数量"></el-table-column>
      </el-table>
      <div class="padding-top-sm" align="center">
        <el-button type="primary" native-type="submit" @click.native.prevent="handleSubmit('formData')">保存</el-button>
        <el-button @click="closeDialog">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import _Find_ from 'lodash/find';
import {getApps} from '@/api/apps';
import constant from '@/utils/constant';
import Promise from 'bluebird';
import {
  getProductsAll,
  // showProducts
} from '@/api/products';
import {
  getProductsConfig,
  saveProductConfig,
  updateProductConfig,
  deleteProductConfig,
  deleteCache,
  putAwayConfig,
  soldOutConfig
} from '@/api/appProducts';

function defaultForm() {
  return {
    appIndex: '',
    productIds: ''
  };
}

export default {
  name: 'appProducts',
  data() {
    return {
      loading: true,
      apps: [],
      products: [],
      appProducts: [],
      title: '',
      showEditorDialog: false,
      formData: defaultForm(),
      searchForm: {
        appIndex: null
      },
      formRules: {
        appIndex: [{required: true, trigger: 'blur', message: '应用Index只能输入数字'}]
      },
      pageSizes: constant.PAGINATION.pageSizes
    };
  },
  /**
   * 初始化钩子
   */
  created() {
    this.loadData();
  },
  methods: {
    /**
     *根据条件查询
     */
    loadData(pager = {}) {
      pager.page = pager.page || 1;
      pager.pageSize = pager.pageSize || this.pageSizes[0];
      this.loading = true;
      Promise.props({
        apps: getApps(),
        products: getProductsAll(),
        appProducts: getProductsConfig(pager)
      }).then(result => {
        this.apps = result.apps;
        this.products = result.products;
        this.appProducts = result.appProducts;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    getAppProducts() {
      this.loading = true;
      // 获取商品配置
      getProductsConfig({
        ...this.searchForm
      }).then(result => {
        this.loading = false;
        this.appProducts = result;
      }).catch(() => {
        this.loading = false;
      });
    },
    /**
     * 一键上架
     */
    putAway() {
      this.loading = true;
      putAwayConfig().then(() => {
        this.loading = false;
        this.loadData();
      }).catch(() => {
        this.loading = false;
      });
    },
    /**
     * 一键下架
     */
    soldOut() {
      this.loading = true;
      soldOutConfig().then(() => {
        this.loading = false;
        this.$message({
          message: '下架成功',
          type: 'success'
        });
        this.loadData();
      }).catch((err) => {
        this.loading = false;
        this.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    /**
     * 清除单个地区缓存
     */
    deleteAppCache(appIndex) {
      deleteCache(appIndex).then(() => {
        this.$message({
          message: '缓存清除成功',
          type: 'success'
        });
      });
    },
    /**
     * 打开商品信息面板
     */
    showDialog(obj) {
      this.showEditorDialog = true;
      if (!obj) {
        this.title = '配置应用商品';
        this.formData = defaultForm();
      } else {
        this.title = '修改应用商品';
        this.formData = {
          ...obj
        };
        let appBind = this.formData.productIds.split(',')
          .map(productId => this._Find_(this.products, {id: parseInt(productId)}))
          .filter(product => product);
        this.initRowSelection(appBind);
      }

    },
    /**
     * 关闭面板
     */
    closeDialog() {
      this.clearForm();
      this.showEditorDialog = false;
    },
    clearForm() {
      this.$refs['formData'].resetFields();
    },

    handleBeforeCloseDialog(done) {
      this.clearForm();
      done();
    },

    /**
     * 提交前验证
     */
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveAppProducts();
        } else {
          this.$message.error('提交失败');
          return false;
        }
      });
    },
    /**
     * 保存商品信息
     */
    saveAppProducts() {
      const loading = this.$loading();
      if (this.formData.id) {
        updateProductConfig(this.formData).then(result => {
          this.showEditorDialog = !this.showEditorDialog;
          loading.close();
          if (result) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.loadData();
          }
        }).catch(() => loading.close());
      } else {
        saveProductConfig(this.formData).then(() => {
          this.showEditorDialog = !this.showEditorDialog;
          loading.close();
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.loadData();
        }).catch(() => loading.close());
      }
    },
    /**
     * 删除
     */
    deleteAppProducts(obj) {
      this.$confirm('确认删除该应用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading();
        deleteProductConfig(obj.id).then(result => {
          loading.close();
          if (result > 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.loadData();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange(val) {
      this.loadData({
        page: this.appProducts && this.appProducts.currentPage,
        pageSize: val
      });
    },
    handleCurrentChange(val) {
      this.loadData({
        page: val,
        pageSize: this.appProducts.pageSize
      });
    },
    _Find_,
    findAppName(index) {
      return this._Find_(this.apps, {appIndex: index}).appName;
    },
    // 当前选中项
    handleSelectionChange(val) {
      const selected = val.map(function (t) {
        return t.id;
      }).join(',');
      this.formData.productIds = selected.split(',').sort((a, b) => a - b).toString();
    },

    /**
     * 设置选中项
     * @param oldBindApps 原始数据列表
     */
    initRowSelection(oldBindApps) {
      this.$nextTick(() => {
        this.$refs.products.doLayout();
        this.$refs.products.clearSelection();
        oldBindApps.forEach(row => {
          this.$refs.products.toggleRowSelection(row);
        });
      });
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.update {
  margin-top: 10px;

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 100%;
    display: block;
  }

  .img-box {
    width: 100px;
    height: 100px;
  }

  .number-input {
    width: 195px;
  }

  .form-item__full-width .el-select,
  .form-item__full-width .el-input-number {
    width: 100%;
  }

}
</style>

<style>
/*这里是elementUI组件自动生成的元素*/

.el-upload-dragger {
  width: 100px;
  height: 100px;
}

.el-input-number .el-input__inner {
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// appProducts.vue?42f8945e